import { yup } from '@medely/ui-kit';
import { validateEndDate } from '../workHistoryForm/schema';

const validateEndDateField = () =>
  yup.mixed().test({
    name: 'valid-end-date',
    test(value, ctx) {
      if (ctx.parent.current_position) {
        return true;
      }
      const errorMessage = validateEndDate({
        endDate: value as Date,
        startDate: ctx.parent.start_date,
      });
      if (!!errorMessage) {
        return ctx.createError({ message: errorMessage });
      }
      return true;
    },
  });

export const referenceValidationSchema = yup.object().shape({
  first_name: yup.string().required('Required'),
  last_name: yup.string().required('Required'),
  title: yup.string().required('Required'),

  phone_number: yup
    .string()
    .nullable()
    .transform((val) => (typeof val === 'string' ? val.trim() : val))
    .test('phone-valid-when-present', 'Please enter a valid phone number', (value) => {
      if (!value) {
        return true;
      }
      try {
        yup
          .string()
          .phone()
          .validateSync(value as string);
        return true;
      } catch {
        return false;
      }
    })
    .notRequired(),

  email: yup.string().email('Invalid email format').required('Required'),

  facility_name: yup.string().required('Required'),

  department: yup.string().when('facility_name', (facilityName, schema) => {
    const value = Array.isArray(facilityName) ? facilityName[0] : facilityName;
    return value === 'new_facility' ? schema.notRequired() : schema.required('Required');
  }),

  facility_name_new: yup.string().when('facility_name', (facilityName, schema) => {
    const value = Array.isArray(facilityName) ? facilityName[0] : facilityName;
    return value === 'new_facility' ? schema.required('Required') : schema.notRequired();
  }),

  department_new: yup
    .string()
    .when('facility_name', (facilityName, schema) => {
      const value = Array.isArray(facilityName) ? facilityName[0] : facilityName;
      return value === 'new_facility' ? schema.required('Required') : schema.notRequired();
    })
    .test('dept-new-required-when-add-unit', 'Required', function (value) {
      const parent = this.parent as {
        department?: string;
        facility_name?: string;
      };
      if (parent.facility_name !== 'new_facility' && parent.department === 'add_new_unit') {
        return !!value;
      }
      return true;
    }),

  current_position: yup.boolean(),
  start_date: yup.string().required('Required'),
  end_date: yup
    .mixed()
    .nullable()
    .when('current_position', {
      is: (value: boolean) => !value,
      then: (schema) => schema.required('Required').concat(validateEndDateField()),
      otherwise: (schema) => schema.nullable(),
    }),
});
